import { z } from 'zod';

export const CalibrationProgressSchema = z.object({
  progress: z.number(),
});

export type CalibrationProgress = z.infer<typeof CalibrationProgressSchema>;
